import React from 'react';
import { motion } from 'framer-motion';
import { useStock } from '../context/StockContext';
export function StockCounter() {
  const {
    available,
    percentSold
  } = useStock();
  return <section className="bg-black py-10 md:py-16 px-4" data-id="element-85">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-86">
        <h2 className="font-bebas text-4xl md:text-5xl text-white text-center mb-8 tracking-wider" data-id="element-87">
          ESTADO DEL DROP:
        </h2>

        <div className="space-y-4" data-id="element-88">
          <div className="relative w-full h-8 bg-gray-800 rounded-full overflow-hidden" data-id="element-89">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: `${percentSold}%`
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="absolute top-0 left-0 h-full bg-gradient-to-r from-misery-purple to-misery-magenta" data-id="element-90" />
          </div>

          <div className="flex justify-between text-white font-inter text-sm md:text-base" data-id="element-91">
            <span className="font-semibold" data-id="element-92">{percentSold}% Vendido</span>
            <span className="font-semibold text-misery-magenta" data-id="element-93">
              {available} Unidades Disponibles
            </span>
          </div>

          <p className="text-gray-400 text-center font-inter text-sm md:text-base italic mt-6" data-id="element-94">
            "Una vez que el contador llegue a 0, este diseño entra a la bóveda.
            No habrá restock. Nunca."
          </p>
        </div>
      </motion.div>
    </section>;
}